export type ModuleLevel = "beginner" | "intermediate" | "advanced";
export type ModuleAudience = "kid" | "teen" | "adult" | "teacher";

export interface Module {
  id: string;
  title: string;
  description: string;
  learningGoals: string[];
  microCourseIds: string[];
  duration: number;
  level: ModuleLevel;
  audience: ModuleAudience;
  prerequisiteModuleIds?: string[];
}

const biasAdultModule: Module = {
  id: "biais_confirmation_adulte",
  title: "Biais de confirmation - Version adulte",
  description:
    "Comprendre comment le biais de confirmation influence tes jugements et decisions, au travail comme dans la vie personnelle.",
  learningGoals: [
    "Reconnaître une situation influencee par le biais",
    "Chercher des informations contradictoires",
    "Identifier ses croyances preexistantes",
    "Limiter l'impact du biais dans ses decisions",
  ],
  microCourseIds: ["bc_mc1", "bc_mc2", "bc_mc3", "bc_mc4", "bc_mc5"],
  duration: 35,
  level: "intermediate",
  audience: "adult",
};

const biasKidModule: Module = {
  id: "biais_confirmation_enfant",
  title: "Biais de confirmation - Version enfant",
  description:
    "Decouvrir que ton cerveau voit surtout ce qui lui donne raison et apprendre a regarder aussi le reste.",
  learningGoals: [
    "Comprendre que le cerveau garde ce qui lui convient",
    "Ecouter un avis oppose pour apprendre",
    "Explorer des contenus varies pour eviter la bulle",
  ],
  microCourseIds: ["bc_kid1", "bc_kid2", "bc_kid3"],
  duration: 15,
  level: "beginner",
  audience: "kid",
};

const biasAliases: Module[] = [
  {
    ...biasAdultModule,
    id: "mod-biais-confirmation-1",
    microCourseIds: ["micro-biais-1"],
    duration: 7,
    level: "beginner",
  },
];

export const demoModules: Module[] = [biasAdultModule, biasKidModule, ...biasAliases];

export const allModules: Module[] = [...demoModules];
